/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const menuItemDtoSchema = z.object({
  id: z.coerce.number().int().optional(),
  title: z.coerce.string().nullable().nullish(),
  href: z.coerce.string().nullable().nullish(),
  parent: z.coerce.number().int().optional(),
  order: z.coerce.number().int().optional(),
});
